import { RadioGroup } from '@playbooks/ui/components/radio-group'
import { ViewMode } from '@playbooks/action-cards-utils'
import { cn } from '@playbooks/ui/lib/utils'
import { Assessment, Response as ResponseType } from '@playbooks/core/src/interfaces/ActionCard'

import Response from './Response'
import { useAppContext } from '../../../contexts/AppContext'

interface SingleSelectProps {
  assessment: Assessment
  responses: ResponseType[]
  onValueChange: (response: ResponseType) => void
}

export function SingleSelect({ responses, onValueChange }: SingleSelectProps) {
  const {
    settings: { viewMode },
  } = useAppContext()

  const isFunnelView = viewMode === ViewMode.FUNNEL
  const isTree = responses.length % 3 === 0
  const shouldLastRespBeWide = responses.length % 2 !== 0 && responses.length % 3 !== 0

  return (
    <div className="w-full">
      <RadioGroup
        className={cn(
          'grid gap-3 group-data-[view=doc]/app:gap-0.5',
          isFunnelView && cn(isTree ? 'grid-cols-3' : 'grid-cols-2'),
        )}
      >
        {responses.map(option => {
          const id = `single-select-${option.id}`
          return (
            <div
              key={id}
              className={shouldLastRespBeWide ? 'last-of-type:col-span-full' : ''}
              onClick={() => {
                onValueChange(option)
              }}
            >
              <Response response={option} iconClass={option.iconClass} isRadioButton isFunnelView={isFunnelView} />
            </div>
          )
        })}
      </RadioGroup>
    </div>
  )
}
